import React from "react";
import UserDetails from "./shared/UserDetails";

const GroupedUserListGroup = ({ letter, users, onUserSelect }) => (
  <div>
    <div className="group-header">{letter}</div>
    <ul>
      {users
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((user) => (
          <li key={user.id} onClick={() => onUserSelect(user)}>
            <UserDetails user={user} />
          </li>
        ))}
    </ul>
  </div>
);

export default GroupedUserListGroup;